import React from "react";
import { Table } from "react-bootstrap";
import { Search } from "lucide-react";

const AvailableLotsPanel = ({
  available,
  filteredAvailable,
  searchAvailable,
  setSearchAvailable,
  checkedAvailable,
  handleSelectAllAvailable,
  handleSelectAvailableRow,
  getCheckedRowBg,
  themeColors,
  ISHelpModal
}) => {
  const {
    borderTheme,
    headingCol,
    textTheme,
    iscolour,
    iscolourDark,
    isdark,
    tableBg,
    tableText,
    tableBorder,
    tableHeaderBg
  } = themeColors;


  const helpLots = Array.isArray(ISHelpModal)
    ? ISHelpModal
    : ISHelpModal?.LotPendHelp ||
    [];

  console.log(helpLots);


  const filteredHelpLots = helpLots.filter((lot) => {
    const q = searchAvailable?.toLowerCase() || "";

    return (
      String(lot?.LotNo || "").toLowerCase().includes(q) ||
      String(lot?.GroupName || "").toLowerCase().includes(q) ||
      String(lot?.QualityType || "").toLowerCase().includes(q) ||
      String(lot?.InwSrNo || "").toLowerCase().includes(q)
    );
  });

  const formatDateOnly = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    if (isNaN(date.getTime())) return "-";

    const pad = (num) =>
      String(num).padStart(2, "0");

    return `${pad(date.getDate())}-${pad(
      date.getMonth() + 1
    )}-${date.getFullYear()}`;
  };


  const formatDateTimeLocal = (value) => {
    if (!value) return "";

    const date = new Date(value);

    if (isNaN(date.getTime())) return "";

    const pad = (num) =>
      String(num).padStart(2, "0");

    return `${date.getFullYear()}-${pad(
      date.getMonth() + 1
    )}-${pad(
      date.getDate()
    )}T${pad(
      date.getHours()
    )}:${pad(
      date.getMinutes()
    )}`;
  };

  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div
        style={{
          border: `1px solid ${borderTheme}`,
          borderRadius: "14px",
          padding: "14px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: isdark === "light"
            ? `linear-gradient(160deg, ${iscolour?.Colour1 || "#fff"} 0%, ${iscolour?.Colour4 || "#fef3e8"} 100%)`
            : `linear-gradient(160deg, ${iscolourDark?.Colour9 || "#2d1f0f"} 0%, ${iscolourDark?.Colour8 || "#6b4423"} 100%)`,
          boxShadow: isdark === "light" ? `0 6px 24px ${iscolour?.Colour6 || "#e6a571"}30` : `0 6px 24px rgba(0,0,0,0.3)`,
          transition: "all 0.3s ease"
        }}
        className="hover-card-glowing"
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "800", fontSize: "15px", letterSpacing: "0.3px", color: headingCol }}>Available Roll Lots</span>
            <span
              style={{
                borderRadius: "20px",
                padding: "3px 10px",
                fontSize: "12px",
                fontWeight: "700",
                background: isdark === "light" ? iscolour?.Colour5 || "#fde9d3" : iscolourDark?.Colour7 || "#7a5637",
                color: isdark === "light" ? iscolour?.Colour9 || "#a66b35" : iscolourDark?.Colour1 || "#fcefd9",
                border: `1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour6 || "#8b5a2b"}`
              }}
            >
              {available.length} Lots
            </span>
          </div>
        </div>

        <div style={{ position: "relative", marginBottom: "16px" }}>
          <Search
            size={16}
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              color: isdark === "light" ? iscolour?.Colour7 || "#d7b08a" : iscolourDark?.Colour5 || "#b07540",
              pointerEvents: "none"
            }}
          />
          <input
            type="text"
            placeholder="Search Available Lots..."
            value={searchAvailable}
            onChange={(e) => setSearchAvailable(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 12px 10px 38px",
              borderRadius: "10px",
              border: `1px solid ${isdark === "light" ? iscolour?.Colour6 || "#e6a571" : iscolourDark?.Colour7 || "#7a5637"}`,
              background: isdark === "light" ? iscolour?.Colour3 || "#faf8f5" : iscolourDark?.Colour8 || "#6b4423",
              color: textTheme,
              fontSize: "13px",
              outline: "none",
              transition: "all 0.2s ease"
            }}
            className="workspace-search-input"
          />
        </div>

        {/* Table Container */}
        <div
          style={{
            maxHeight: "480px",
            overflowY: "auto",
            border: `1px solid ${borderTheme}`,
            borderRadius: "10px"
          }}
          className="theme-scroll custom-workspace-scroll"
        >
          <Table hover responsive className="custom-workspace-table" style={{ margin: 0, fontSize: "13px", background: tableBg, color: tableText, borderColor: tableBorder }}>
            <thead
              style={{
                position: "sticky",
                top: 0,
                zIndex: 2
              }}
            >
              <tr>


                <th
                  className="text-center"
                  style={{
                    width: "45px",
                    background: "transparent"
                  }}
                >
                  <input
                    type="checkbox"
                    className="custom-checkbox"
                    checked={
                      filteredHelpLots.length > 0 &&
                      filteredHelpLots.every((lot, index) => {
                        const id = lot?.InwCode ?? index;
                        return !!checkedAvailable[id];
                      })
                    }
                    onChange={(e) => {
                      const checked = e.target.checked;

                      handleSelectAllAvailable(
                        filteredHelpLots.map(
                          (lot, index) => lot?.InwCode ?? index
                        ),
                        checked
                      );
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                </th>

                <th style={{ background: "transparent" }}>
                  Lot No
                </th>



                <th style={{ background: "transparent" }}>
                  Inward Date
                </th>

                <th style={{ background: "transparent" }}>
                  Inward Sr No
                </th>

                <th style={{ background: "transparent" }}>
                  Group Name
                </th>

                <th style={{ background: "transparent" }}>
                  Quality Specs
                </th>

                <th className="text-end" style={{ background: "transparent" }}>
                  Taka
                </th>

                <th className="text-end" style={{ background: "transparent" }}>
                  Meter
                </th>

                <th className="text-end" style={{ background: "transparent" }}>
                  Avg Weight
                </th>

                <th style={{ background: "transparent" }}>
                  Operator
                </th>

                <th style={{ background: "transparent" }}>
                  Shift
                </th>

                <th style={{ background: "transparent" }}>
                  In Time
                </th>

                <th style={{ background: "transparent" }}>
                  Out Time
                </th>

                <th style={{ background: "transparent" }}>
                  Weight
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredHelpLots.length === 0 ? (
                <tr style={{ background: tableBg }}>
                  <td
                    colSpan={13}
                    className="text-center py-4 text-secondary"
                    style={{ background: "transparent" }}
                  >
                    No available lots found.
                  </td>
                </tr>
              ) : (
                filteredHelpLots.map((lot, index) => {

                  const id =
                    lot?.InwCode ??
                    index;

                  const isChecked =
                    !!checkedAvailable[id];

                  const rowBg =
                    getCheckedRowBg(
                      isChecked,
                      false
                    );

                  return (
                    <tr
                      key={id}
                      style={{
                        background: rowBg,
                        color: tableText,
                        cursor: "pointer"
                      }}
                      onClick={() =>
                        handleSelectAvailableRow(
                          id,
                          !isChecked
                        )
                      }
                    >

                      {/* Checkbox */}
                      <td
                        className="text-center"
                        onClick={(e) =>
                          e.stopPropagation()
                        }
                        style={{
                          background: "transparent"
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(e) =>
                            handleSelectAvailableRow(
                              id,
                              e.target.checked
                            )
                          }
                          className="custom-checkbox"
                        />
                      </td>


                      {/* Lot No */}
                      <td
                        className="fw-semibold"
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?.LotNo ?? "-"}
                      </td>



                      {/* Inward Date */}
                      <td
                        style={{
                          background: "transparent",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {lot?.InwDate
                          ? formatDateOnly(lot.InwDate)
                          : "-"}
                      </td>


                      {/* Inward Sr No */}
                      <td
                        style={{
                          background: "transparent",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {lot?.InwSrNo ?? "-"}
                      </td>


                      {/* Party */}
                      <td
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?.GroupName ?? "-"}
                      </td>


                      {/* Quality */}
                      <td
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?.QualityType ?? "-"}
                      </td>



                      {/* Taka */}
                      <td
                        className="text-end fw-bold"
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?.Taka ?? 0}
                      </td>


                      {/* Meter */}
                      <td
                        className="text-end fw-bold"
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?.Meter ?? 0}
                      </td>


                      {/* Avg Weight */}
                      <td
                        className="text-end fw-bold"
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?._AvgWeight ?? "-"}
                      </td>


                      {/* Operator */}
                      <td
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?._Operator ?? "-"}
                      </td>


                      {/* Shift */}
                      <td
                        style={{
                          background: "transparent"
                        }}
                      >
                        {lot?._Shift ?? "-"}
                      </td>


                      {/* In Time */}
                      <td
                        style={{
                          background: "transparent",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {lot?._InTime
                          ? formatDateTimeLocal(
                            lot._InTime
                          ).replace("T", " ")
                          : "-"}
                      </td>


                      {/* Out Time */}
                      <td
                        style={{
                          background: "transparent",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {lot?._OutTime
                          ? formatDateTimeLocal(
                            lot._OutTime
                          ).replace("T", " ")
                          : "-"}
                      </td>

                      {/* Out Time */}
                      <td
                        style={{
                          background: "transparent",
                          whiteSpace: "nowrap"
                        }}
                      >
                        {lot?._Weight ?? "-"}
                      </td>


                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default AvailableLotsPanel;
